module.exports = __webpack_public_path__ + "img/fw-logo.e4eaf996.png";